// http://phpjs.org/functions/nl2br/ ...
function nl2br(str) {
  if (!str) return str
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')
}

export default nl2br
